import {
  FREELANCER_GET_ARTICLES_REQUEST,
  FREELANCER_GET_ARTICLES_SUCCESS,
  FREELANCER_GET_ARTICLES_FAIL,
  FREELANCER_GET_CATEGORIES_REQUEST,
  FREELANCER_GET_CATEGORIES_SUCCESS,
  FREELANCER_GET_CATEGORIES_FAIL,
  FREELANCER_REMOVE_ARTICLE_REQUEST,
  FREELANCER_REMOVE_ARTICLE_SUCCESS,
  FREELANCER_REMOVE_ARTICLE_FAIL,
  FREELANCER_GET_ARTICLE_REQUEST,
  FREELANCER_GET_ARTICLE_SUCCESS,
  FREELANCER_GET_ARTICLE_FAIL,
  FREELANCER_EDIT_ARTICLE_REQUEST,
  FREELANCER_EDIT_ARTICLE_SUCCESS,
  FREELANCER_EDIT_ARTICLE_FAIL,
  FREELANCER_EDIT_USERARTICLE_REQUEST,
  FREELANCER_EDIT_USERARTICLE_SUCCESS,
  FREELANCER_EDIT_USERARTICLE_FAIL,
  FREELANCER_NEW_USERARTICLE_REQUEST,
  FREELANCER_NEW_USERARTICLE_SUCCESS,
  FREELANCER_NEW_USERARTICLE_FAIL
} from "../actions/freelancer";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {},

  editArticleRequest: false,
  successBackMsg: ""
};

const freelancer = (state = initialState, action) => {
  switch (action.type) {
    case FREELANCER_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case FREELANCER_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        articles: action.data.data,
        articlesPagination: {
          currentPage: action.data.current_page,
          lastPage: action.data.last_page
        }
      };
    case FREELANCER_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors
      };
    case FREELANCER_GET_CATEGORIES_REQUEST:
      return {
        ...state,
        getCategoriesRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case FREELANCER_GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        categories: action.data
      };
    case FREELANCER_GET_CATEGORIES_FAIL:
      return {
        ...state,
        getCategoriesRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors
      };
    case FREELANCER_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {},
        selectedArticle: {}
      };
    case FREELANCER_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedArticle: {}
      };
    case FREELANCER_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedArticle: {}
      };

    case FREELANCER_GET_ARTICLE_REQUEST:
      return {
        ...state,
        getArticleRequest: true,
        successMsg: "",
        errorMsg: "",
        errors: {},
        selectedArticle: {}
      };
    case FREELANCER_GET_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticleRequest: false,
        successMsg: "",
        errorMsg: "",
        errors: {},
        selectedArticle: action.data
      };
    case FREELANCER_GET_ARTICLE_FAIL:
      return {
        ...state,
        getArticleRequest: false,
        successMsg: "",
        errorMsg: action.msg,
        errors: action.errors,
        selectedArticle: {}
      };
    case FREELANCER_EDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case FREELANCER_EDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case FREELANCER_EDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };
    case FREELANCER_EDIT_USERARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case FREELANCER_EDIT_USERARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case FREELANCER_EDIT_USERARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };
    case FREELANCER_NEW_USERARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case FREELANCER_NEW_USERARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case FREELANCER_NEW_USERARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };

    default:
      return state;
  }
};

export default freelancer;
